import { render, staticRenderFns } from "./appExplain.vue?vue&type=template&id=005da032&scoped=true&"
import script from "./appExplain.vue?vue&type=script&lang=js&"
export * from "./appExplain.vue?vue&type=script&lang=js&"
import style0 from "./appExplain.vue?vue&type=style&index=0&id=005da032&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005da032",
  null
  
)

export default component.exports